import React, { useState } from 'react'
import {
  Separator,
  StyledFooter,
  StyledSocials,
  StyledSVG,
  StyledText,
  StyledTextBody,
  StyledTextTitle,
  StyleIcon,
  Subscribe,
} from './FooterNetwork.styled'
import { footerData } from '../../data/footer'
import FooterModal from '../FooterModal/FooterModal'
import theme from '../../theme/theme-style'
import { IconTypeEnum } from '../../theme/icons'

const FooterDataEnum = Object.freeze({
  SocialMedia: 'social-media',
  Newsletter: 'newsletter',
})

const TARGET = '_blank'

const FooterNetwork = ({ isMobile, light }) => {
  const [show, setShow] = useState(false)

  const sub = footerData.find(
    (element) => element.component === FooterDataEnum.Newsletter
  )

  const title = (isMobile ? sub.mobile : sub.title) + ' :'
  const socials = footerData.find(
    (element) => element.component === FooterDataEnum.SocialMedia
  )
  const socialsNav = socials.links.map((link) => (
    <li key={link.id}>
      <StyledSVG
        href={link.path}
        isSvg={true}
        svg={link.svg}
        color={theme.colors.unique.white}
        height="27.5"
        width="27.5"
        type={IconTypeEnum.footer}
        target={TARGET}
        ariaLabel={link.title}
      />
    </li>
  ))
  return (
    <StyledFooter role="navigation">
      <StyledSocials>{socialsNav}</StyledSocials>
      {!light && (
        <>
          <Separator />
          <Subscribe onClick={() => setShow(true)}>
            <StyledText>
              <StyledTextTitle>{title}</StyledTextTitle>
              <StyledTextBody>Your mail</StyledTextBody>
            </StyledText>
            <StyleIcon />
          </Subscribe>
          <FooterModal
            show={show}
            isMobile={isMobile}
            onClose={() => {
              setShow(false)
            }}
          />
        </>
      )}
    </StyledFooter>
  )
}

FooterNetwork.propTypes = {}

export default FooterNetwork
